import { render } from "./AdminSubcategories.vue?vue&type=template&id=3b3a13ae&scoped=true"
import script from "./AdminSubcategories.vue?vue&type=script&lang=js"
export * from "./AdminSubcategories.vue?vue&type=script&lang=js"

import "./AdminSubcategories.vue?vue&type=style&index=0&id=3b3a13ae&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b3a13ae"]])

export default __exports__